import React from 'react'
import ServiceRequest from './ServiceRequest'
import {useUserState} from '../../../context/UserContext'
import {useUIDispatch} from '../../../context/UIContext'
import {fetchServiceRequests} from '../../../utils/servicerequests'
import styled from 'styled-components'
import ShowMore from '../../../components/ShowMore'
import {useViewFetch} from '../../../utils/fetch'

const ServiceRequestListContainer = ({truncated}) => {
  const {user} = useUserState()
  const uiDispatch = useUIDispatch()
  const emId = user.employee.id
  const numberOfRecordsToFetch = truncated ? 1 : 1000

  const {data} = useViewFetch({
    api: fetchServiceRequests,
    parameters: {
      emId,
      numberOfRecords: numberOfRecordsToFetch
    },
    initialState: {data: [], total: 0},
    onChangeOf: [emId, numberOfRecordsToFetch]
  })

  const {data: serviceRequests, total: numberOfRecords} = data

  const onShowMore = () => {
    uiDispatch({
      type: 'setContent',
      payload: {content: 'SERVICE_MORE_LIST', parentPage: 'DASHBOARD'}
    })
  }

  const parentPage = truncated ? 'DASHBOARD' : 'SERVICE_MORE_LIST'

  return (
    <ListContainer>
      {serviceRequests.map(request => (
        <ServiceRequest
          key={request.activityLogId}
          parentPage={parentPage}
          request={request}
        />
      ))}
      {truncated && (
        <ShowMore recordCount={numberOfRecords} onClick={onShowMore} />
      )}
    </ListContainer>
  )
}

export default ServiceRequestListContainer

const ListContainer = styled.div`
  max-width: 1200px;
  flex: 1;
  background-color: #ffffff;
  border-radius: 5px;
  overflow-y: scroll;

  @media (max-width: 420px) {
    border-radius: 0;
  }
`

ServiceRequestListContainer.defaultProps = {
  truncated: false
}
